import React from "react";
import styled from "styled-components";
import { Color, FontSize, Radius, ZIndexes, transparentize } from "@glossy";

const Menu = styled.div<{
  open?: boolean;
  fullWidth?: boolean;
  pullRight?: boolean;
  maxHeight?: number;
  dropUp?: boolean;
  hasChevron?: boolean;
}>`
  position: absolute;
  top: ${(props) => (props.dropUp ? "auto" : "100%")};
  bottom: ${(props) => (props.dropUp ? "100%" : "auto")};
  left: ${(props) => (props.pullRight ? "auto" : 0)};
  z-index: ${ZIndexes.Top};

  /* none by default, but block on "open" of the menu */
  display: ${(props) => (props.open ? "block" : "none")};
  min-width: 160px;
  margin: 2px 0 ${(props) => (props.dropUp ? "2px" : 0)}; /* override default ul */
  font-size: ${FontSize.Medium};
  text-align: left; /* Ensures proper alignment if parent has it changed (e.g., modal footer) */
  border-radius: ${(props) =>
    props.hasChevron ? Radius.MediumLarge : Radius.Small};
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.16), 0 2px 2px 0 rgba(0, 0, 0, 0.16),
    0 1px 3px 0 rgba(0, 0, 0, 0.16);
  background-clip: padding-box;
  overflow: ${(props) => (props.maxHeight ? "auto" : "hidden")};
  list-style: none;
  border: 1px solid ${transparentize(0.85, Color.Black)};
  background-color: ${Color.White};
  width: ${(props) =>
    props.fullWidth ? "100%" : props.hasChevron ? "200px" : null};
  right: ${(props) => (props.pullRight ? 0 : null)};
  max-height: ${(props) => (props.maxHeight ? props.maxHeight : null)};

  > div {
    display: ${(props) => (props.open ? "block" : "none")};
  }
`;

interface IProps {
  open?: boolean;
  fullWidth?: boolean;
  pullRight?: boolean;
  className?: string;
  closeOnClick?: boolean;
  maxHeight?: number;
  dropUp?: boolean;
  reference?: React.RefObject<HTMLDivElement>;
  children: React.ReactNode;
  onClose?: () => void;
  hasChevron?: boolean;
}

const KomonDropdownMenu = React.forwardRef(
  (
    {
      open,
      pullRight,
      fullWidth,
      className,
      children,
      onClose,
      maxHeight,
      dropUp,
      closeOnClick = true,
      hasChevron = false,
    }: IProps,
    ref: React.Ref<HTMLDivElement>
  ) => {
    const onClick = React.useCallback(
      (event: React.FormEvent<HTMLElement>) => {
        const element = event.target as HTMLElement;
        if (element.tagName !== "INPUT" && closeOnClick && onClose) {
          onClose();
        }
      },
      [closeOnClick, onClose]
    );
    return (
      <Menu
        ref={ref}
        pullRight={pullRight}
        fullWidth={fullWidth}
        open={open}
        onClick={onClick}
        maxHeight={maxHeight}
        dropUp={dropUp}
        hasChevron={hasChevron}
        className={className}
      >
        <div>{children}</div>
      </Menu>
    );
  }
);

KomonDropdownMenu.displayName = "KomonDropdownMenu";
export default KomonDropdownMenu;
